import styled, { css } from 'styled-components';

import { BRAND_COLORS } from './colors';
import { TYPOGRAPHY } from './typography';

interface AnchorProps {
  $isBold?: boolean;
  $isUnderlined?: boolean;
}
export const Anchor = styled.a<AnchorProps>`
  color: ${BRAND_COLORS.darkGreen};
  cursor: pointer;

  ${({ $isBold }) => $isBold ? TYPOGRAPHY.OPEN_SANS.semiBold : TYPOGRAPHY.OPEN_SANS.base}

  &:disabled {
    color: ${BRAND_COLORS.darkGray};
    text-decoration: none;
    pointer-events: none;
    cursor: not-allowed;
  }

  &:not(:disabled) {
    &:hover {
      color: ${BRAND_COLORS.lightGreen};
      text-decoration: underline;
    }
    ${({ $isUnderlined }) => $isUnderlined && css`
      text-decoration: underline;
    `}
  }

`;
